import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const initialState = {
  inspectionPage: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  inspectionDetail: { data: null, loading: false },
  feedbackList: { data: [], loading: false },
  confirm: { type: '', title: '', content: '', visible: false, loading: false },
  dialog: { type: '', visible: false, loading: false },
  search: null,
  loading: false,
};

export default { namespaced:  true, state: initialState, actions, mutations, getters } as IStore<IModuleState>;
